/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliCreateSubjectDto } from '../../models/amoxcalli-create-subject-dto';
import { AmoxcalliSubjectDtoApiResponse } from '../../models/amoxcalli-subject-dto-api-response';

export interface ApiSubjectsPost$Plain$Params {
      body?: AmoxcalliCreateSubjectDto
}

export function apiSubjectsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiSubjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliSubjectDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiSubjectsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliSubjectDtoApiResponse>;
    })
  );
}

apiSubjectsPost$Plain.PATH = '/api/subjects';
